module.exports = __webpack_public_path__ + "img/undraw_Online_messaging_re_qft3.e3952ac9.svg";